import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LocalStorageService } from './local-storage.service';
import { AuthService } from './auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private localStorageService: LocalStorageService, private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isLoginRequest(request)) {
      return next.handle(request);
    }

    const clonedRequest = request.clone({
      headers: this.getHeaders(request),
    });

    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.authService.logout();
        }

        return throwError(error);
      })
    );
  }

  private getHeaders(request: HttpRequest<any>): HttpHeaders {
    const authorizationHeader = 'Authorization';

    const bearer = this.localStorageService.getItem('bearer');

    if (!bearer) {
      return request.headers.delete(authorizationHeader);
    }

    return request.headers.set(authorizationHeader, `Bearer ${bearer}`);
  }

  private isLoginRequest(request: HttpRequest<any>) {
    return request.url.indexOf('/login') > -1;
  }
}
